export default "__VITE_ASSET__ydO74Gy16$om$6aLh07BFw__";